import React from 'react';
import UserIntegrateTemplate from '../components/user-integrate/UserIntegrateTemplate';

function UserIntegratePage() {
  return <UserIntegrateTemplate />;
}

export default UserIntegratePage;
